import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { OkrViewAccessType } from "@webapp/okrs/okr-views/models/okr-views.models";

@Component({
  selector: "okr-views-grid-access-cell",
  templateUrl: "./okr-views-grid-access-cell.component.html",
  styleUrls: ["./okr-views-grid-access-cell.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OkrViewsGridAccessCellComponent {
  @Input() public accessType: OkrViewAccessType;
}
